/* eslint-disable @typescript-eslint/naming-convention */
export enum HelpPageTags {
  Inventory = 'inventory',
  AddInventory = 'inventory-add',
  EditInventory = 'inventory-edit',
  SearchInventory = 'inventory-search',
  Dashboard = 'dashboard',
  DashboardFiltering = 'dashboard-filtering',
  DashboardReportTypes = 'dashboard-report-types',
  Payments = 'payments',
  PaymentsQuickStartGuide = 'payments-quick-start-guide',
  PaymentsReferenceGuide = 'payments-reference-guide',
  PaymentsVideoTutorial = 'payments-video-tutorial',
}
